import { useDebounceFn } from "@vueuse/core";
import type { FormKitNode } from "@formkit/core";

type Callback = () => void;

/**
 * Trigger a callback once after the next event has occurred.
 * Debounces the event listener using `debounce` as ms interval.
 */
function afterEvent(
	node: FormKitNode,
	event: string,
	callback: Callback,
	debounce: number = 100,
) {
	const recepit = node.on(
		event,
		() =>
			void useDebounceFn(() => {
				callback(); // trigger the callback
				node.off(recepit); // remove the listener
			}, debounce),
	);
}

/**
 * Trigger a callback after the next verification has completed.
 * This relies on the `submit-raw` event being triggered during validation.
 */
export function afterValidation(node: FormKitNode, callback: () => void) {
	afterEvent(node, "submit-raw", callback, 100);
}
